export default {
    container: 'bg-white dark:bg-black rounded-lg shadow-lg border border-zinc-300 dark:border-black p-2',
    links_container: 'flex flex-col divide-y divide-gray-100 dark:divide-gray-900 -my-2',
    links: 'flex flex-col space-y-1 py-2',
    link: 'relative w-full flex items-center space-x-2 px-6 py-3 text-sm rounded-lg text-gray-800 hover:text-black hover:bg-neutral-100 active:bg-neutral-200 group transition-all',
    icon: 'fa-regular text-xs text-gray-600 w-[15px] group-hover:text-black transition-all',
    // Danger variant (destructive/negative actions, e.g. "Signaler la demande") — additive, the base
    // `link`/`icon` above are unchanged so existing menus keep their styling. Only the text/icon go red;
    // the hover/active background stays the standard neutral (no pink tint).
    link_danger: 'relative w-full flex items-center space-x-2 px-6 py-3 text-sm rounded-lg text-branding-red hover:bg-neutral-100 active:bg-neutral-200 group transition-all',
    icon_danger: 'fa-regular text-xs text-branding-red w-[15px] transition-all',
};
